export default __webpack_public_path__ + "static/smiley-b71fbaddf064b8854df4143f1f0305ed.png";